<div class="content">
  <div class="container-fluid">
    <div class="page-title">
      <h1>Gateway Management</h1>
    </div>
    <div class="page-filter clearfix border-b-radius-none" style="margin: 0">
      <div class="page-title sub-title">
        <h5 class="float-left">SNMP MIB/Trap</h5>
      </div>
    </div>
    <div class="page-content border-t-radius-none">
      <p-table class="deviceTable pageAllOptions" [columns]="gatewayMgtList_cols" [value]="gatewayMgtList" [rows]="10" [paginator]="true" [scrollable]="true">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr>
            <td style="width:200px" class="col-nowrap">
              <a *ngIf="rowData.type === 'Mib'" routerLink="/management/gateway/mib-detail/{{rowData.hashId}}">{{rowData.name}}</a>
              <a *ngIf="rowData.type === 'Trap'" routerLink="/management/gateway/trap-detail/{{rowData.hashId}}">{{rowData.name}}</a>
            </td>
            <td style="width: 150px" class="col-nowrap">{{rowData.brand}}</td>
            <td style="width: 150px" class="col-nowrap">{{rowData.type}}</td>
            <td style="width: 150px" class="col-nowrap">{{(rowData.updatetime != null) ? ((rowData.updatetime) | date: 'yyyy/MM/dd') : ''}}</td>
            <!-- <td style="width: 150px" class="col-nowrap type">
              <div class="value api">
                <p-toggleswitch [ngModel]="rowData.status" (onChange)="handleChange($event)"></p-toggleswitch>
                <span *ngIf="rowData.status else FortwoFactorAuthenticationTag">{{'Enable' | translate}}</span>
                <ng-template #FortwoFactorAuthenticationTag>
                  <span>{{'Disable' | translate}}</span>
                </ng-template>
              </div>
            </td> -->
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="gatewayMgtList_cols.length">
              <div class="ui-emptymessage">No Data found</div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="container-fluid">
    <div class="page-filter clearfix border-b-radius-none" style="margin: 4em 0 0 0">
      <div class="page-title sub-title">
        <h5 class="float-left">Attribute Management</h5>
        <div>
          <button pButton type="button" label="Add" icon="fa fa-plus" class="{{Confirm_button}} update" (click)="showDialog()"></button>
          <button pButton type="button" label="Edit" icon="fa fa-pencil-square-o" [disabled]="selectedAttribute == null" class="{{Confirm_button}} update" (click)="showEditDialog()"></button>
          <button pButton type="button" label="Delete" icon="fa fa-trash" class="{{Confirm_button}}" [disabled]="selectedAttribute == null" (click)="showConfirmDialog()"></button>
        </div>
      </div>
    </div>
    <div class="page-content border-t-radius-none">
      <p-table class="deviceTable pageAllOptions" [columns]="attributeMgtList_cols" [value]="attributeMgtList" [rows]="10" [paginator]="true" [scrollable]="true"
      selectionMode="single" [(selection)]="selectedAttribute">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr [pSelectableRow]="rowData">
            <td style="width: 200px" class="col-nowrap">{{rowData.name}}</td>
            <td style="width: 150px" class="col-nowrap">{{rowData.fieldName}}</td>
            <td style="width: 150px" class="col-nowrap">
              <span *ngFor="let item of categoryList">
                <span *ngIf="rowData.category === item.Value">{{item.Category}}</span>
              </span>
            </td>
            <td style="width: 420px">{{rowData.desc}}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="attributeMgtList_cols.length">
              <div class="ui-emptymessage">No Data found</div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-dialog header="{{dialogInput.UpdateType | translate}}" [(visible)]="displayDialog" [modal]="true" [style]="{'width': '450px'}"[baseZIndex]="10000">
  <div class="dialog-content">
    <div class="form-group">
      <label translate>Attribute Name</label>
      <input type="text" size="20" maxlength="20" class="form-control pInputText" [(ngModel)]="dialogInput.name"  pInputText>
    </div>
    <div class="form-group">
      <label translate>Field Name</label>
      <input type="text" class="form-control pInputText" [(ngModel)]="dialogInput.fieldName" pInputText>
    </div>
    <div class="form-group">
      <label translate>Category</label>
      <div class="select">
        <p-select [options]="categoryOptions" [(ngModel)]="dialogInput.category" [style]="{'width':'100%'}" [disabled]="dialogInput.UpdateType === 'Edit Attribute'" appendTo="body"></p-select>
      </div>
    </div>
    <div class="form-group">
      <label translate>Description</label>
      <textarea [rows]="5" size="150" maxlength="150" pInputTextarea [(ngModel)]="dialogInput.desc"></textarea>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="saveAttributeData();" label="{{'Save' | translate}}" class="ui-button-danger" [disabled]="!dialogInput.name || !dialogInput.fieldName"></button>
    <button type="button" pButton (click)="displayDialog=false;" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- Confirm -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="displayConfirmDialog" [modal]="true" [style]="{'width': '450px'}" [baseZIndex]="10000" class="ConfirmDialog">
  <div cla="page-content-body">
    <p translate>Do you really want to delete this record?</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton label="{{'Confirm' | translate}}" class="ui-button-danger"(click)="deleteAttributeData()"></button>
      <button type="button" pButton (click)="displayConfirmDialog=false" label="{{'Cancel' | translate}}"class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>

<p-toast [style]="{marginTop: '70px'}"></p-toast>
